module.exports = __webpack_public_path__ + "media/img/illustrations/S2U-Create-48cbe3a65ecd5998e8b0821ae5a1bf94.svg";